import axios from 'axios';
import store from '../store/store';
import { authLogout } from '../store/authSlice';
import { API_URL } from '../config';

export type ApiRequest = {
    method: 'get' | 'post' | 'put' | 'delete',
    url: string,
    data?: object,
    params?: object,
};

export type ApiResponse = { 
    data: ApiResponseObject | null,
    error: ApiResponseError | null,
};

export type ApiResponseObjectField = 'token'|'user'|'users'|'event'|'events'|'attendee'|'attendees'|'slot'|'slots'|'request'|'requests'|'categories'|'catalog'|'file'|'translation'|'languages';

export type ApiResponseObject = {
    [s in ApiResponseObjectField]: object | string | number | boolean | null
};

export type ApiResponseError = {
    code: number,
    text: { ru: string, en: string },
};

export const ApiResponseErrorUnknown: ApiResponseError = {
    code: 0,
    text: {
        ru: 'Неизвестная ошибка',
        en: 'Unknown error',
    }
};

const api = async (options: ApiRequest): Promise<ApiResponse> => {
    try {
        const result = await axios(options);
        return { data: result.data, error: null };
    } catch (error) {
        if(axios.isAxiosError(error) && error.response) {
            if(error.response.status === 401) {
                delete axios.defaults.headers.common['Authorization'];
                store.dispatch(authLogout());
            }
            // В ответе может не быть объекта ApiResponseError, к примеру
            // если ошибку выдал Nginx и до приложения запрос вообще не дошел.
            if(!error.response.data.hasOwnProperty('code') || !error.response.data.hasOwnProperty('text')) {
                // Настройки Nginx могут резать загружаемые файлы раньше приложения
                if(error.response.status === 413) {
                    return {
                        error: {
                            code: 413,
                            text: {
                                ru: 'Загруженный файл слишком велик',
                                en: 'The uploaded file is too large',
                            }
                        },
                        data: null,
                    };
                }
                // Неизвестная ошибка не понятно от кого
                console.log('Неизвестная ошибка в ответе axios');
                return { error: ApiResponseErrorUnknown, data: null };
            } else {
                // Вернем ошибку пришедшую от серверного приложения
                return { error: error.response.data, data: null };
            }
        }        
        // По идее такого быть не может, но пусть
        console.log('Неизвестная ошибка в вызове API');
        return { error: ApiResponseErrorUnknown, data: null };
    }
};

export const get = async (method: string, data?: object): Promise<ApiResponse> => {
    return await api({
        method: 'get',
        url: API_URL + method,
        params: data
    });
};

export const post = async (method: string, data?: object): Promise<ApiResponse> => {
    return await api({
        method: 'post',
        url: API_URL + method,
        data
    });
};

export const put = async (method: string, data?: object): Promise<ApiResponse> => {
    return await api({
        method: 'put',
        url: API_URL + method,
        data
    });
};

export const del = async (method: string, data?: object): Promise<ApiResponse> => {
    return await api({
        method: 'delete',
        url: API_URL + method,
        data
    });
};
